<template>
	<WpLink v-if="data && data.url" :url="data.url" :title="data.title" :target="data.target">
		<span v-html="title"></span>
		<slot></slot>
	</WpLink>
	<div class="no-link" v-else>
		<slot></slot>
	</div>
</template>

<script>
import WpLink from '@/components/elements/WpLink'

export default {
	name: 'acf-link',
	props: ['data'],
	computed: {
		title() {
			let title = ''
			if (this.data.title === '') {
				title = 'Les mer ...'
			} else {
				title = this.data.title
			}
			return title
		},
	},
	components: {
		WpLink,
	},
}
</script>
